var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCou4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5658 13.4767C11.2691 13.086 11.1035 12.6111 11.093 12.1202L3.84502 11.0894L2 24.0427L9.24795 25.0735L9.24829 25.0738C9.39716 24.6071 9.68706 24.1983 10.0775 23.903C10.4696 23.609 10.9441 23.4461 11.4344 23.438L12.7289 14.3062C12.2639 14.1587 11.8572 13.8684 11.5659 13.4767L11.5658 13.4767Z",
    fill: "#E66100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0078 10.8334L16.4266 12.0969C16.3836 12.5837 16.1884 13.0449 15.8686 13.4145C15.5579 13.7985 15.1307 14.0706 14.6514 14.1899L15.349 23.3836C15.8348 23.4309 16.2948 23.6258 16.6671 23.9416C17.0493 24.257 17.3208 24.6859 17.4421 25.1666L34.0007 23.8796L33.0078 10.8334ZM22.349 14.1045C22.8052 14.0714 23.2361 14.316 23.4418 14.7245C23.6476 15.1329 23.5873 15.6248 23.2892 15.9713C22.9911 16.3181 22.5135 16.4513 22.0792 16.3092C21.6445 16.1672 21.3382 15.7775 21.3025 15.3217C21.279 15.0212 21.3764 14.7242 21.573 14.4956C21.7692 14.267 22.0485 14.1263 22.349 14.1045L22.349 14.1045ZM26.5818 21.5541V21.5545C26.1266 21.581 25.6998 21.332 25.4991 20.9229C25.2985 20.5137 25.3629 20.0238 25.6626 19.6805C25.9624 19.3367 26.4387 19.2066 26.8716 19.35C27.3043 19.4938 27.6085 19.8828 27.6436 20.3372C27.6695 20.6404 27.5707 20.9412 27.3707 21.1708C27.1704 21.4001 26.8856 21.5384 26.5817 21.5544L26.5818 21.5541ZM21.543 21.5541L20.9693 21.0271L27.1013 14.5L27.6749 15.027L21.543 21.5541Z",
    fill: "#E66100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCou4);
export default __webpack_public_path__ + "static/media/cou-(4).955efbe9e29f55986099d7129203a8a6.svg";
export { ForwardRef as ReactComponent };